
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';



@Injectable()
export class AccountNameService {

  constructor() { }

  private accountnameAnnouncedSource = new Subject<string>();
  // Observable string streams
  accountnameAnnounced = this.accountnameAnnouncedSource.asObservable();
  // Service message commands
  announceAccountName(accountname: string) {
    this.accountnameAnnouncedSource.next(accountname);
  }
} //end of class

@Injectable()
export class AccountIdService {

  constructor() { }

  private accountidAnnouncedSource = new Subject<string>();
  // Observable string streams
  accountidAnnounced = this.accountidAnnouncedSource.asObservable();
  // Service message commands
  announceAccountId(account_id: string) {
    this.accountidAnnouncedSource.next(account_id);
  }
} //end of class

@Injectable()
export class AgencyIdService {

  constructor() { }

  private agencyidAnnouncedSource = new Subject<string>();
  // Observable string streams
  agencyidAnnounced = this.agencyidAnnouncedSource.asObservable();
  // Service message commands
  announceAgencyId(agency_id: string) {
    this.agencyidAnnouncedSource.next(agency_id);
  }
} //end of class




//
//
// @Injectable()
// export class AccountServiceBehavior {
//
//   //https://medium.com/@weswhite/angular-behaviorsubject-service-60485ef064fc
//
//   constructor() { }
//
//   private accountAnnouncedSourceBehavior = new BehaviorSubject<string>(null);
//   // Observable string streams
//   accountAnnouncedBehavior = this.accountAnnouncedSourceBehavior.asObservable();
//   // Service message commands
//   announceAccount(account_id: string) {
//     this.accountAnnouncedSourceBehavior.next(account_id);
//   }
//
// }
//
//
// @Injectable()
// export class AgencyServiceBehavior {
//
//   constructor() { }
//
//   private agencyAnnouncedSourceBehavior = new BehaviorSubject<string>(null);
//   // Observable string streams
//   agencyAnnouncedBehavior = this.agencyAnnouncedSourceBehavior.asObservable();
//   // Service message commands
//   announceAgency(agency_id: string) {
//     this.agencyAnnouncedSourceBehavior.next(agency_id);
//   }
//
// }
//
// @Injectable()
// export class ModelServiceBehavior {
//
//   constructor() { }
//
//   private modelAnnouncedSourceBehavior = new BehaviorSubject<string>(null);
//   // Observable string streams
//   modelAnnouncedBehavior = this.modelAnnouncedSourceBehavior.asObservable();
//   // Service message commands
//   announceModel(model_id: string) {
//     this.modelAnnouncedSourceBehavior.next(model_id);
//   }
//
// }
//
// @Injectable()
// export class DataServiceBehavior {
//
//   constructor() { }
//
//   private dataAnnouncedSourceBehavior = new BehaviorSubject<string>(null);
//   // Observable string streams
//   dataAnnouncedBehavior = this.dataAnnouncedSourceBehavior.asObservable();
//   // Service message commands
//   announceData(data_id: string) {
//     this.dataAnnouncedSourceBehavior.next(data_id);
//   }
//
// }
//
//
// @Injectable()
// export class LinkServiceBehavior {
//
//   constructor() { }
//
//   private linkAnnouncedSourceBehavior = new BehaviorSubject<object>(null);
//   // Observable string streams
//   linkAnnouncedBehavior = this.linkAnnouncedSourceBehavior.asObservable();
//   // Service message commands
//   announceLink(link_hash: object) {
//     this.linkAnnouncedSourceBehavior.next(link_hash);
//   }
//
// }
//
//
//
//
// @Injectable()
// export class SnackBarMessageServiceBehavior {
//
//   /*
//   SEND A MESSAGE
//   this.snackBarMessageServiceBehavior.announceSnackBarMessage({'message':'Data is Uploaded'});
//
//   The subcriber lives in app components.  Any components can send a message to pop up a snack bar
//   */
//
//   constructor() { }
//
//   private snackBarMessageSourceBehavior = new BehaviorSubject<object>(null);
//   // Observable string streams
//   snackBarMessageAnnouncedBehavior = this.snackBarMessageSourceBehavior.asObservable();
//   // Service message commands
//   announceSnackBarMessage(link_hash: object) {
//     this.snackBarMessageSourceBehavior.next(link_hash);
//   }
//
// }
